export default {
  title: "EssayLite – Expert Essay Help",
  description: "Get expert writing help to craft better essays and research papers",
  canonical: "https://www.essaylite.com/",
  openGraph: {
    type: 'website',
    locale: 'en_US',
    url: 'https://www.essaylite.com',
    site_name: 'EssayLite',
    title: 'EssayLite – Expert Essay Help',
    description: 'Get expert writing help to craft better essays and research papers',
    images: [
      {
        url: '/favicon.ico', // Changed to reference the public folder's favicon.ico
        width: 32, // Adjusted to a typical favicon size (verify your actual size)
        height: 32, // Adjusted to a typical favicon size (verify your actual size)
        alt: 'EssayLite Favicon',
      },
    ],
  },
  twitter: {
    handle: '@essaylite', // Replace with your real handle if available
    site: '@www.essaylite.com',
    cardType: 'summary_large_image',
    title: 'EssayLite – Expert Essay Help',
    description: 'Get expert writing help to craft better essays and research papers',
    image: '/favicon.ico', // Changed to reference the public folder's favicon.ico
  },
  additionalMetaTags: [
    {
      name: 'keywords',
      content: 'essay writing, expert help, academic assistance, plagiarism-free, fast delivery',
    },
    {
      name: 'robots',
      content: 'index, follow',
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1.0',
    },
  ],
};